import React, { FC, useMemo } from 'react'

import { alpha, Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

import { TradeStatus } from '../../pages/TradingLog/types'

import { TradeStatusCellProps } from './types'

type BoolLabel = 'success' | 'fail'

export const TradeStatusCell: FC<TradeStatusCellProps> = ({ status }) => {
  const { spacing, palette } = useTheme()
  const { t } = useTranslation()

  const statusType = typeof status === 'boolean' ? 'boolean' : 'tradeStatus'

  const resolvedStatus = useMemo(() => {
    if (typeof status === 'boolean') {
      return (status ? 'success' : 'fail') as BoolLabel
    }
    return status // TradeStatus
  }, [status])

  const { textColor, backgroundColor } = useMemo(() => {
    // default (neutral / other)
    let textColor = palette.blue[500] as string
    let backgroundColor = alpha(textColor, 0.16)

    const isFail = resolvedStatus === TradeStatus.loss || resolvedStatus === 'fail'
    const isSuccess = resolvedStatus === TradeStatus.win || resolvedStatus === 'success'

    if (isFail) {
      textColor = palette.red[700] as string
      backgroundColor = alpha(palette.error.main, 0.16)
    } else if (isSuccess) {
      textColor = palette.green[500] as string
      backgroundColor = alpha(palette.green[400] as string, 0.16)
    }

    return { textColor, backgroundColor }
  }, [palette, resolvedStatus])

  return (
    <Box
      width={'fit-content'}
      padding={`${spacing(0.2)} ${spacing(1.5)}`}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      borderRadius={spacing(1.25)}
      ml="auto"
      bgcolor={backgroundColor}
    >
      <Typography
        fontSize={12}
        fontWeight={800}
        color={textColor}
        align="center"
        textTransform="uppercase"
        lineHeight={spacing(2.63)}
      >
        {statusType === 'boolean'
          ? t(`tradingAccountsPage.importHistory.status.${resolvedStatus}`, t(resolvedStatus))
          : t(`tradingLogPage.tradeStatus.${resolvedStatus}`, t(resolvedStatus))}
      </Typography>
    </Box>
  )
}
